import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { skillGroups } from '../data/skills';
const section = sections[2];
export function Skills() {
  return <div data-id="element-275" data-mp="96w0vdin9lf0">
      <PageHeader section={section} intro="The practised, personal capabilities Janice brings to a board table — how she chairs, negotiates, develops people and holds judgement under pressure." data-id="element-276" data-mp="96m9blhyb677" />

      <div className="mt-12 grid gap-px border border-slate-200 bg-slate-200 lg:grid-cols-2" data-id="element-277" data-mp="11tqj03rzo8pb">
        {skillGroups.map(group => {
        const Icon = group.icon;
        return <section key={group.group} className="bg-white p-8" data-id="element-278" data-mp="s34bkwufeohp">
              <div className="flex items-center gap-4" data-id="element-279" data-mp="n6duq7asrov8">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 text-gold-dark" data-id="element-280" data-mp="n3j7y94b9ryn">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-281" data-mp="1ftrj3h0fjc3q" />
                </span>
                <h2 className="font-serif text-xl leading-snug text-navy" data-id="element-282" data-mp="64u133sryj2v">
                  {group.group}
                </h2>
              </div>

              <ul className="mt-7 space-y-6" data-id="element-283" data-mp="b359rb7c2nji">
                {group.skills.map(skill => <li key={skill.name} data-id="element-284" data-mp="3sjn52myvu3ei">
                    <div className="flex items-baseline justify-between gap-4" data-id="element-285" data-mp="1dvi1wgej6vx">
                      <span className="text-[14px] font-medium text-navy" data-id="element-286" data-mp="1bsfkcy2blab">
                        {skill.name}
                      </span>
                      <span className="shrink-0 font-serif text-[13px] text-gold-dark" data-id="element-287" data-mp="3nllcnbfkgrqd">
                        {skill.level}
                      </span>
                    </div>
                    <div role="presentation" className="mt-2 h-[3px] w-full bg-slate-200" data-id="element-288" data-mp="3ekdqtsu8ljd6">
                      <div className="h-full bg-navy" style={{
                  width: `${skill.level}%`
                }} data-id="element-289" data-mp="17ugwuuidpjkj" />
                    </div>
                    <p className="mt-2 text-[12px] leading-relaxed text-slateink-light" data-id="element-290" data-mp="1bcmqs2cr1o8w">
                      {skill.note}
                    </p>
                  </li>)}
              </ul>
            </section>;
      })}
      </div>
    </div>;
}